/**
 * @desc 时效看板-详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.TimelinessDashboardResponseDto>;
export function request(tdno: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/timelinessDashboard/details/${tdno}`, {
      method: "GET",

      ...options,
    }),
  );
}
